import React, { useState, useCallback } from 'react';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import { MdPlayArrow } from 'react-icons/md';
import { toast } from 'react-toastify';
import Lottie from 'lottie-react-web';
import ContainedButton from '~/components/layout/form/containedButton';
import OutlinedButton from '~/components/layout/form/outlinedButton';
import axios from 'axios';
import { HeaderContainer } from '../styles';
import {
  Container,
  ContainerButtons,
  FormContainer,
  ButtonLink,
  SuccessIconContainer,
} from './styles';
import api from '~/services/api';
import success from '~/animations/success.json';

const EmailMessage = ({ step, setStep, useInfo, setUseInfo }) => {
  const [loading, setLoading] = useState();

  const requestGetAccessToken = useCallback(async () => {
    const req = axios.create({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": "pt-BR",
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
      baseURL: process.env.REACT_APP_API_URL_OAUTH,
    });

    const header = {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      grant_type: 'client_credentials',
    };

    let access_token = '';

    try {
      const response = await req.post('oauth/access-token', body, parameters);
      access_token = response.data.access_token;
    } catch (error) {
      const erro = error.response;
      if (erro) {
        const { message } = error.response.data;
        if (error.response.status !== 401) {
          toast.error(message);
        }
      } else if (error.response.status !== 401) {
        toast.error('Ocorreu um erro interno na aplicação');
      }
    }

    return access_token;
  }, []);

  const handleSubmit = useCallback(async () => {
    setLoading(true);
    const { login } = useInfo;

    const headers = {
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    api
      .post(
        'industrial/customer/v1/users/reset-password',
        { login },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        setStep(3);
      })
      .catch((error) => {
        setLoading(false);
        const erro = error.response;
        if (erro) {
          const { message } = error.response.data;
          if (error.response.status !== 401) {
            toast.error(message);
          }
        } else if (error.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  }, [useInfo]);

  return (
    <>
      <Container>
        <HeaderContainer>
          <span>
            <MdPlayArrow />
            &nbsp;&nbsp;Redefinir senha
          </span>
          <h1>Um link de confirmação foi enviado para seu e-mail</h1>
          <h2>Clique no link para redefinir sua senha</h2>
        </HeaderContainer>

        <FormContainer as="div">
          <SuccessIconContainer>
            <Lottie
              options={{
                animationData: success,
                loop: false,
              }}
            />
          </SuccessIconContainer>
          <ContainerButtons>
            {/* <ContainedButton
              block
              continue
              loading={loading}
              id="Avançar"
              width="100%"
              TrailingIcon={() => <IoMdArrowForward size={20} />}
              onClick={() => { handleSubmit() }}
            >
              Continuar
            </ContainedButton> */}
            <OutlinedButton
              width="100%"
              LeadingIcon={() => <IoMdArrowBack size={20} />}
              onClick={() => {
                setStep(1);
              }}
            >
              Voltar
            </OutlinedButton>
          </ContainerButtons>
        </FormContainer>
      </Container>
    </>
  );
};

export default EmailMessage;
